import React from 'react';

import RecordingRequestTable from './RecordingRequestTable';
import SectionHeading from 'components/SectionHeading';

export default function ViewPendingRecordingRequestsPage() {
  return (
    <>
      <SectionHeading title="PENDING MODULE REQUESTS" />
      <RecordingRequestTable />
    </>
  );
}
